import { Helmet } from "react-helmet-async";
import Leaderboard from "src/sections/overview/dashboards/views/brand-pulse/leaderboard";

export default function LeaderboardMarketLeaders() {
    return (
        <>
            <Helmet>
                <title>Market Leaders</title>
            </Helmet>

            <Leaderboard />
        </>
    );
}
